import { PanelKey_AddProtocolData, PanelKey_EventFeed, PanelKey_Findings, PanelKey_Home, PanelKey_HPI, PanelKey_Inbox, PanelKey_NextSteps, PanelKey_PatientDataLoader, PanelKey_ProtocolInfo, PanelKey_ProvideInfo, PanelKey_Settings, PanelKey_SmartDocs, PanelKey_Spotlight, } from '@app/advisor-v5-shared';
import { AdvisorPanel_Spotlight } from './ui/panels/AdvisorPanel_Spotlight/AdvisorPanel_Spotlight.js';
import { AdvisorPanel_SmartDocs } from './ui/panels/AdvisorPanel_SmartDocs/AdvisorPanel_SmartDocs.js';
import { AdvisorPanel_Findings } from './ui/panels/AdvisorPanel_Findings/AdvisorPanel_Findings.js';
import { AdvisorPanel_HPI } from './ui/panels/AdvisorPanel_HPI/AdvisorPanel_HPI.js';
import { AdvisorPanel_AddProtocolData } from './ui/panels/AdvisorPanel_AddProtocolData/AdvisorPanel_AddProtocolData.js';
import { AdvisorPanel_Inbox } from './ui/panels/AdvisorPanel_Inbox/AdvisorPanel_Inbox.js';
import { AdvisorPanel_Settings } from './ui/panels/AdvisorPanel_Settings/AdvisorPanel_Settings.js';
import { AdvisorPanel_PatientDataLoader } from './ui/panels/AdvisorPanel_PatientDataLoader/AdvisorPanel_PatientDataLoader.js';
import { AdvisorPanel_NextSteps } from './ui/panels/AdvisorPanel_NextSteps/AdvisorPanel_NextSteps.js';
import { AdvisorPanel_ProtocolInfo } from './ui/panels/AdvisorPanel_ProtocolInfo/AdvisorPanel_ProtocolInfo.js';
import { AdvisorPanel_ProvideInfo } from './ui/panels/AdvisorPanel_ProvideInfo/AdvisorPanel_ProvideInfo.js';
import { AdvisorPanel_Home } from './ui/panels/AdvisorPanel_Home/AdvisorPanel_Home.js';
import { AdvisorPanel_EventFeed } from './ui/panels/AdvisorPanel_EventFeed/AdvisorPanel_EventFeed.js';
export const PanelKeyToRenderer = {
    [PanelKey_Spotlight]: AdvisorPanel_Spotlight,
    [PanelKey_SmartDocs]: AdvisorPanel_SmartDocs,
    [PanelKey_Findings]: AdvisorPanel_Findings,
    [PanelKey_HPI]: AdvisorPanel_HPI,
    [PanelKey_ProtocolInfo]: AdvisorPanel_ProtocolInfo,
    [PanelKey_ProvideInfo]: AdvisorPanel_ProvideInfo,
    [PanelKey_AddProtocolData]: AdvisorPanel_AddProtocolData,
    [PanelKey_Inbox]: AdvisorPanel_Inbox,
    [PanelKey_Settings]: AdvisorPanel_Settings,
    [PanelKey_PatientDataLoader]: AdvisorPanel_PatientDataLoader,
    [PanelKey_NextSteps]: AdvisorPanel_NextSteps,
    [PanelKey_Home]: AdvisorPanel_Home,
    [PanelKey_EventFeed]: AdvisorPanel_EventFeed,
};
//# sourceMappingURL=consts.js.map